import React, { useState,useEffect } from 'react';
export const CalculateurBenefices = () => {

  const allocJournaliere = 57.60
  const nbDayByMonth = [28, 30, 31]
  const salaireJournalierBrutDeReference = 114.9

  function formatEUro(number) {
    let numberInEuro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number)
    return numberInEuro
  }
  const [caByMonth, setcaByMonth] = useState(0)
  const [caByYears, setCaByYears] = useState(0)
  const [seuilAre, setSeuilAre] = useState("")
  const [caMicroMonth, setCaMicroMonth] = useState(0)
  const [caMicroYears, setCaMicroYears] = useState(0)
  const [externalCharge, setexternalCharge] = useState(0)

  const [tarifJournalier,setTarifJournalier] = useState(0)
  const [nbJoursTravaille,setNbJoursTravaille] = useState(120)
  const [chargesDivers,setChargesDivers]= useState(0)

  let chiffreAffaire = tarifJournalier * nbJoursTravaille
  let chargesObligatoires1AvecAcre = chiffreAffaire*0.11+(758)+(103)
  let chargesObligatoires1SansAcre = chiffreAffaire*0.222+1500
  let beneficesBrutAvecAcre = chiffreAffaire - chargesObligatoires1AvecAcre
  let beneficesBrutSansAcre = chiffreAffaire - chargesObligatoires1SansAcre  
  let beneficesNetAvecAcre = beneficesBrutAvecAcre - chargesDivers
  let beneficesNetSansAcre = beneficesBrutSansAcre - chargesDivers

  let estimByMonthAvecAcre = beneficesNetAvecAcre / 12
  let estimByMonthSansAcre = beneficesNetSansAcre / 12

/*
  if(chiffreAffaire < montantAreByYear){setMontantAre(montantAreByYear - (ca30*0.70))}else{setMontantAre(0)}



*/

const [tjm1,settjm1] = useState(0)
const [nbJoursTravaille1,setnbJoursTravaille1] = useState(0)
const [chiffreAffaire1,setchiffreAffaire1] = useState(0)
const [depenses1,setdepenses1] = useState(0)
const [estimAre1,setestimAre1] = useState(0)
const [chargesObligatoiresAcre1,setchargesObligatoiresAcre1] = useState(0)
const [chargesObligatoires1,setchargesObligatoires1] = useState(0)

useEffect(() => {
if(chiffreAffaire1>3447){
  setestimAre1(0)
}else{
  setestimAre1((((57.60*30)-((chiffreAffaire1*0.66)*0.70))*0.951))
}
setchargesObligatoiresAcre1((chiffreAffaire1*0.132)+(758/12)+(103/12))
setchargesObligatoires1((chiffreAffaire1*0.242)+(1500/12))
}, [chiffreAffaire1])




const [tjm2,settjm2] = useState(0)
const [nbJoursTravaille2,setnbJoursTravaille2] = useState(0)
const [chiffreAffaire2,setchiffreAffaire2] = useState(0)
const [depenses2,setdepenses2] = useState(0)
const [estimAre2,setestimAre2] = useState(0)
const [chargesObligatoiresAcre2,setchargesObligatoiresAcre2] = useState(0)
const [chargesObligatoires2,setchargesObligatoires2] = useState(0)

useEffect(() => {
if(chiffreAffaire2>41938.5){
  setestimAre2(0)
}else{
  setestimAre2((((57.60*365)-((chiffreAffaire2*0.66)*0.70))*0.951))
}
setchargesObligatoiresAcre2((chiffreAffaire2*0.132)+(758)+(103))
setchargesObligatoires2((chiffreAffaire2*0.242)+(1500))
}, [chiffreAffaire2])




  return (

    <div id="articleContent" className="CalculateurBenefices">
      <a class="button only" target="_blank"   onClick={(event) => {window.print()} }>Imprimer ces calcules</a>
<div className="recapByMonth recap">
<p><a href="https://docs.google.com/spreadsheets/d/1WH1x8lyHNnhAZZdS7QDbsUyapo71E9BJe0YoJ6TM-1A/edit?usp=sharing" target="_blank">Voir livre des recettes et des dépenses ici</a></p>
<h3><span>Estimation de la micro par MOIS</span></h3>

<p>Jusqu'à 72600 euros de CA, si création en Mars, ne pas dépasser 60500€</p>

{chiffreAffaire1>3447?<div className="info">Pas d'ARE car seuil de 3447€ dépassé</div>:""}

<form>
<div className="totaux">
  <div>Bénéf. brut <span>avec et sans l'Acre</span></div>
  <div className="calc">{formatEUro(chiffreAffaire1-chargesObligatoiresAcre1)}</div>
  <div className="calc">{formatEUro(chiffreAffaire1-chargesObligatoires1)}</div>
  <div>Bénéf. net <span>avec et sans l'Acre</span></div>
  <div className="calc">{formatEUro(chiffreAffaire1-chargesObligatoiresAcre1-depenses1)}</div>
  <div className="calc highlight">{formatEUro(chiffreAffaire1-chargesObligatoires1-depenses1)}</div>
  <div>Bénéf. net + ARE <span>avec et sans l'Acre</span></div>
  <div className="calc">{formatEUro(chiffreAffaire1-chargesObligatoiresAcre1-depenses1+estimAre1)}</div>
  <div className="calc">{formatEUro(chiffreAffaire1-chargesObligatoires1-depenses1+estimAre1)}</div>
</div>
<h4><span>Calcule du chiffre d'affaire</span></h4>
<p>En moyenne, un freelance travail entre 10 et 15 jours par mois</p>
<div>
  <div>
    <label for="tjm1">TJM</label>
    <input type="number" name="tjm1" id="tjm1"  min="0" max="9999" placeholder="---" onChange={(e) => { 
      settjm1(e.target.value) 
      document.getElementById("chiffreAffaire1").value = null
      setchiffreAffaire1(e.target.value*nbJoursTravaille1)
      }} />
  </div>
  <div className="operator">
  ×
  </div>
  <div>
    <label for="nbJoursTravaille1">Nb de jours</label>
    <input type="number" name="nbJoursTravaille1" id="nbJoursTravaille1" placeholder="---" min="0" max="9999" onChange={(e) => { 
      setnbJoursTravaille1(e.target.value) 
      document.getElementById("chiffreAffaire1").value = null
      setchiffreAffaire1(e.target.value*tjm1)
      
      }} />
  </div>
  <div  className="operator">
    =
  </div>
  <div>
    <label for="chiffreAffaire1">Chiffre d'affaire</label>
    <input type="number" name="chiffreAffaire1" id="chiffreAffaire1" placeholder={tjm1*nbJoursTravaille1} onChange={(e) => { 
      setchiffreAffaire1(e.target.value)
      settjm1(0)
      setnbJoursTravaille1(0)
      document.getElementById("tjm1").value = null
      document.getElementById("nbJoursTravaille1").value = null
      
      }} />
      
  </div>
</div>
<h4><span>Estimation des dépenses</span></h4>
<p>Dépenses Pro. et perso estimée à 1146€ <a target="_blank" href="https://docs.google.com/spreadsheets/d/1dT3_KsUUHmosMiebg9CMb03EwnHDzqzQbyU7radYnCM/edit?usp=sharing">voir le calcul</a></p>
<div className="depenses1">
    <label for="depenses1">Dépenses</label>
    <input type="number" name="depenses1" placeholder="0"  id="depenses1" onChange={(e) => { 
      setdepenses1(e.target.value)
      }} />
  </div>
<h4><span>Estimation des charges obligatoires</span></h4>
<p>Avec option de versement libératoire et <strong>1500€</strong> de CFE pour l'estimation sans l'Acre</p>
<div className="chargesObligatoires1">
  <div>
    <div>Avec l'Acre</div>
    <div className="calc">{formatEUro(chargesObligatoiresAcre1)}</div>
  </div>
  <div>
    <div>Sans l'Acre</div>
    <div className="calc">{formatEUro(chargesObligatoires1)}</div>
  </div>
</div>


  <h4><span>Estimation de l'ARE net (-4.90% d'impôt)</span></h4>
<p>Salaire brut journalier de référence  : <strong>114,9€</strong>, ARE par jour : <strong>57,60€</strong></p>
<div className="estimAre1">
  <div>
    <div className="calc">
      {formatEUro(estimAre1)}
    </div>
 
  </div>
</div>

</form>
</div>
<div className="recapByYears recap">
<p><a href="https://docs.google.com/spreadsheets/d/1WH1x8lyHNnhAZZdS7QDbsUyapo71E9BJe0YoJ6TM-1A/edit?usp=sharing" target="_blank">Voir livre des recettes et des dépenses ici</a></p>
<h3><span>Estimation de la micro par AN</span></h3>
<p>Jusqu'à 72600 euros de CA, si création en Mars, ne pas dépasser 60500€</p>

{chiffreAffaire2>27666.6666&&chiffreAffaire2<29333.3333?<div className="important firstYear">1ère année : TVA, dépassement du seuil de 27666.666€, passage à un autre régime de TVA si dépassement pendant 2 années consécutives </div>:""}
{chiffreAffaire2>29333.3333?<div className="important firstYear">1ère année : TVA, attention dépassement du seuil de 2933.3333€, passage immédiat à un autre régime de TVA</div>:""}
{chiffreAffaire2>60500?<div className="important firstYear">1ère année : Attention, seuil de C.A pour la micro dépassé</div>:""}


{chiffreAffaire2>72600?<div className="important">Attention : Seuil de C.A pour la micro dépassé</div>:""}
{chiffreAffaire2>33200&&chiffreAffaire2<35200?<div className="important">TVA : Dépassement du seuil de 33200€, passage à un autre régime de TVA si dépassement pendant 2 années consécutives</div>:""}
{chiffreAffaire2>35200?<div className="important">TVA : Attention dépassement du seuil de 35200€, passage immediat à un autre régime de TVA</div>:""}
{chiffreAffaire2>41938.5?<div className="info">Pas d'ARE car seuil de 41938.5€ dépassé</div>:""}

<form>
<div className="totaux">
  <div>Bénéf. brut <span>avec et sans l'Acre</span></div>
  <div className="calc">{formatEUro(chiffreAffaire2-chargesObligatoiresAcre2)}</div>
  <div className="calc">{formatEUro(chiffreAffaire2-chargesObligatoires2)}</div>
  <div>Bénéf. net <span>avec et sans l'Acre</span></div>
  <div className="calc">{formatEUro(chiffreAffaire2-chargesObligatoiresAcre2-depenses2)}</div>
  <div className="calc highlight">{formatEUro(chiffreAffaire2-chargesObligatoires2-depenses2)}</div>
  <div>Bénéf. net + ARE <span>avec et sans l'Acre</span></div>
  <div className="calc">{formatEUro(chiffreAffaire2-chargesObligatoiresAcre2-depenses2+estimAre2)}</div>
  <div className="calc">{formatEUro(chiffreAffaire2-chargesObligatoires2-depenses2+estimAre2)}</div>
  <div>Moy. net mensuel <span>avec Acre et ARE</span></div>
  <div className="calc">{formatEUro((chiffreAffaire2-chargesObligatoiresAcre2-depenses2+estimAre2)/12)}</div>
  <div>Moy. net mensuel <span>sans Acre et sans ARE</span></div>
  <div className="calc highlight">{formatEUro((chiffreAffaire2-chargesObligatoires2-depenses2)/12)}</div>
</div>

<h4><span>Calcule du chiffre d'affaire</span></h4>
<p>En moyenne, un freelance travail entre 120 et 145 jours par an</p>

<div>
  <div>
    <label for="tjm2">TJM</label>
    <input type="number" name="tjm1" id="tjm2"  min="0" max="9999" placeholder="---" onChange={(e) => { 
      settjm2(e.target.value) 
      document.getElementById("chiffreAffaire2").value = null
      setchiffreAffaire2(e.target.value*nbJoursTravaille2)
      }} />
  </div>
  <div className="operator">
  ×
  </div>
  <div>
    <label for="nbJoursTravaille2">Nb de jours</label>
    <input type="number" name="nbJoursTravaille1" id="nbJoursTravaille2" placeholder="---" min="0" max="9999" onChange={(e) => { 
      setnbJoursTravaille2(e.target.value) 
      document.getElementById("chiffreAffaire2").value = null
      setchiffreAffaire2(e.target.value*tjm2)
      
      }} />
  </div>
  <div  className="operator">
    =
  </div>
  <div>
    <label for="chiffreAffaire2">Chiffre d'affaire</label>
      
    <input type="number" name="chiffreAffaire2" id="chiffreAffaire2" placeholder={tjm2*nbJoursTravaille2} onChange={(e) => { 
      setchiffreAffaire2(e.target.value)
      settjm2(0)
      setnbJoursTravaille2(0)
      document.getElementById("tjm2").value = null
      document.getElementById("nbJoursTravaille2").value = null
      
      }} />
      
  </div>
</div>
<h4><span>Estimation des dépenses</span></h4>
<p>Dépenses Pro. et perso estimée à 13751€ <a target="_blank" href="https://docs.google.com/spreadsheets/d/1dT3_KsUUHmosMiebg9CMb03EwnHDzqzQbyU7radYnCM/edit?usp=sharing">voir le calcul</a></p>
<div className="depenses2">
    <label for="depenses2">Dépenses</label>
    <input type="number" name="depenses2" placeholder="0"  id="depenses2" onChange={(e) => { 
      setdepenses2(e.target.value)
      
      }} />

  </div>
<h4><span>Estimation des charges obligatoires</span></h4>
<p>Avec option de versement libératoire et <strong>1500€</strong> de CFE pour l'estimation sans l'Acre</p>
<div className="chargesObligatoires2">
  <div>
    <div>Avec l'Acre</div>
    <div className="calc">{formatEUro(chargesObligatoiresAcre2)}</div>
  </div>
  <div>
    <div>Sans l'Acre</div>
    <div className="calc">{formatEUro(chargesObligatoires2)}</div>
  </div>
</div>


  <h4><span>Estimation de l'ARE net (-4.90% d'impôt)</span></h4>
<p>Salaire brut journalier de référence  : <strong>114,9€</strong>, ARE par jour : <strong>57,60€</strong></p>
<div className="estimAre2">
  <div>
    <div className="calc">
      {formatEUro(estimAre2)}
    </div>
 
  </div>
</div>

</form>
</div>

      <table className="areProvMensuel">
        <thead>
          <tr>
            <th>ARE : Provision mensuel temporaire</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>Nombre de jours dans le mois</th>
            <th>{nbDayByMonth[0]}</th>
            <th>{nbDayByMonth[1]}</th>
            <th>{nbDayByMonth[2]}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Provision temporaire de <strong>70%</strong> des ARE</td>
            <td>{formatEUro(((allocJournaliere * nbDayByMonth[0]) - (allocJournaliere * nbDayByMonth[0] * 0.049)) * 0.70)}</td>
            <td>{formatEUro(((allocJournaliere * nbDayByMonth[1]) - (allocJournaliere * nbDayByMonth[1] * 0.049)) * 0.70)}</td>
            <td>{formatEUro(((allocJournaliere * nbDayByMonth[2]) - (allocJournaliere * nbDayByMonth[2] * 0.049)) * 0.70)}</td>
          </tr>
          <tr>
            <td>Provision temporaire de <strong>80%</strong> des ARE</td>
            <td>{formatEUro(((allocJournaliere * nbDayByMonth[0]) - (allocJournaliere * nbDayByMonth[0] * 0.049)) * 0.80)}</td>
            <td>{formatEUro(((allocJournaliere * nbDayByMonth[1]) - (allocJournaliere * nbDayByMonth[1] * 0.049)) * 0.80)}</td>
            <td>{formatEUro(((allocJournaliere * nbDayByMonth[2]) - (allocJournaliere * nbDayByMonth[2] * 0.049)) * 0.80)}</td>
          </tr>
        </tbody>
      </table>

      <table className="are areEstimationMensuelle">
        <thead>
          <tr>
            <th>ARE : Estimation Annuelle</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Montant de l'allocation journalière sur une année</td>
            <td>{formatEUro(allocJournaliere * 365)}</td>
          </tr>
          <tr>
            <td>Montant des ARE - Prélevement à la source de <strong>4.90%</strong></td>
            <td>{formatEUro((allocJournaliere * 365) - ((allocJournaliere * 365) * 0.049))}</td>
          </tr>
      <tr>
        <td className="caByMonth">Chiffre d'affaire dans l'année</td>
        <td className="inputChange"><input type="number" name="caByMonth" id="caByMonth" placeholder="---" required onChange={(e) => { setCaByYears(e.target.value) }} /></td>
      </tr>
          <tr>
            <td>Chiffre d'affaire - abattement pour frais professionnelles de <strong>34%</strong> (activités libérales)</td>
            <td>{formatEUro(caByYears - (caByYears * 0.34))}</td>
          </tr>
              <tr>
                <td><strong>70%</strong> du CA (après l'abattement)</td>
                <td>{formatEUro(caByYears - (caByYears * 0.34) - ((caByYears - (caByYears * 0.34)) * 0.3))}</td>
              </tr>
              <tr>
                <td>Montant des ARE reversé</td>
                <td>{formatEUro(((allocJournaliere * 365)) - ((allocJournaliere * 365) * 0.049) - (caByYears - (caByYears * 0.34) - ((caByYears - (caByYears * 0.34)) * 0.3)))}</td>
              </tr>
              <tr className="totalAREcaByMonth">
                <td>Total ARE + CA</td>
                <td>{formatEUro(((allocJournaliere * 365)) - ((allocJournaliere * 365) * 0.049) - (caByYears - (caByYears * 0.34) - ((caByYears - (caByYears * 0.34)) * 0.3)) + (+caByYears))}</td>
              </tr>
            </tbody>
          </table>

          <table className="are areEstimationAnnuelle">
            <thead>
              <tr>
                <th>ARE : Estimation mensuels</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <th>Montant de l'allocation journalière</th>
                <th colSpan="3">{formatEUro(allocJournaliere)}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Nombre de jours dans le mois</td><td>{nbDayByMonth[0]}</td><td>{nbDayByMonth[1]}</td><td>{nbDayByMonth[2]}</td>
              </tr>
              <tr>
                <td>Montant des ARE brut</td><td>{formatEUro(allocJournaliere * nbDayByMonth[0])}</td><td>{formatEUro(allocJournaliere * nbDayByMonth[1])}</td><td>{formatEUro(allocJournaliere * nbDayByMonth[2])}</td>
              </tr>
              <tr>
                <td>Montant des ARE - Prélevement à la source de <strong>4.90%</strong></td><td>{formatEUro((allocJournaliere * nbDayByMonth[0]) - (allocJournaliere * nbDayByMonth[0] * 0.049))}</td><td>{formatEUro((allocJournaliere * nbDayByMonth[1]) - (allocJournaliere * nbDayByMonth[1] * 0.049))}</td><td>{formatEUro((allocJournaliere * nbDayByMonth[2]) - (allocJournaliere * nbDayByMonth[2] * 0.049))}</td>
              </tr>
              <tr>
                <td className="caByMonth">Chiffre d'affaire dans le mois</td>
                <td colSpan="3" className="inputChange"><input type="number" placeholder="---" name="caByMonth" id="caByMonth" required onChange={(e) => { setcaByMonth(e.target.value) }} /></td>

              </tr>
              <tr>
                <td>Chiffre d'affaire - abattement pour frais professionnelles de <strong>34%</strong> (activités libérales)</td><td colSpan="3">{formatEUro(caByMonth - (caByMonth * 0.34))}</td>
              </tr>
              <tr>
                <td><strong>70%</strong> du CA (après l'abattement)</td><td colSpan="3">{formatEUro(caByMonth - (caByMonth * 0.34) - ((caByMonth - (caByMonth * 0.34)) * 0.3))}</td>
              </tr>

              <tr>
                <td>Montant des ARE reversé</td>
                <td>{formatEUro((allocJournaliere * nbDayByMonth[0]) - (allocJournaliere * nbDayByMonth[0] * 0.049) - (caByMonth - (caByMonth * 0.34) - ((caByMonth - (caByMonth * 0.34)) * 0.3)))}</td>
                <td>{formatEUro((allocJournaliere * nbDayByMonth[1]) - (allocJournaliere * nbDayByMonth[1] * 0.049) - (caByMonth - (caByMonth * 0.34) - ((caByMonth - (caByMonth * 0.34)) * 0.3)))}</td>
                <td>{formatEUro((allocJournaliere * nbDayByMonth[2]) - (allocJournaliere * nbDayByMonth[2] * 0.049) - (caByMonth - (caByMonth * 0.34) - ((caByMonth - (caByMonth * 0.34)) * 0.3)))}</td>
              </tr>
              <tr className="totalAREcaByMonth">
                <td>Total ARE + CA</td>
                <td>{formatEUro((allocJournaliere * nbDayByMonth[0]) - (allocJournaliere * nbDayByMonth[0] * 0.049) - (caByMonth - (caByMonth * 0.34) - ((caByMonth - (caByMonth * 0.34)) * 0.3)) + (+caByMonth))}</td>
                <td>{formatEUro((allocJournaliere * nbDayByMonth[1]) - (allocJournaliere * nbDayByMonth[1] * 0.049) - (caByMonth - (caByMonth * 0.34) - ((caByMonth - (caByMonth * 0.34)) * 0.3)) + (+caByMonth))}</td>
                <td>{formatEUro((allocJournaliere * nbDayByMonth[2]) - (allocJournaliere * nbDayByMonth[2] * 0.049) - (caByMonth - (caByMonth * 0.34) - ((caByMonth - (caByMonth * 0.34)) * 0.3)) + (+caByMonth))}</td>
              </tr>
            <tr>
              <td>Montant à ne pas dépasser (salaire journalier brut de référence : 114.9 €)</td>
            <td>{formatEUro(salaireJournalierBrutDeReference*28)}</td>  
            <td>{formatEUro(salaireJournalierBrutDeReference*30)}</td>  
            <td>{formatEUro(salaireJournalierBrutDeReference*31)}</td>  
            </tr>
            </tbody>
          </table>






          <table className="microMonth">
            <thead>
              <tr>
                <th>Estimation par MOIS<br/>Micro Entreprise (jusqu'à 72600 euros de CA)</th>
                <th>2021</th>
                <th>2022</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chiffre d'affaire</td>
                <td colSpan='2' className="inputChange"><input type="number" placeholder="---"  name="caByMonth" id="caByMonth" required onChange={(e) => { setCaMicroMonth(e.target.value) }} /></td>
               
              </tr>
              <tr>
                <td>Charges sociales
                  <ul>
                    <li>Avec l'Acre (11% du CA, CSG/CRDS de 758€, contribution à la formation professionnelles 103€)</li>
                    <li>Sans l'Acre (22% du CA, contribution à la formation professionnelles 0.2% du CA)</li>
                  </ul>
                </td>
                <td>{formatEUro((caMicroMonth*0.11)+(758/12)+(103/12))}</td>
                <td>{formatEUro((caMicroMonth*0.22)+(caMicroMonth*0.02))}</td>
                </tr>
                <tr>
                <td>Impôt : Versement libératoire de 2.2% du CA</td>
                <td>{formatEUro(caMicroMonth*0.022)}</td>
                <td>{formatEUro(caMicroMonth*0.022)}</td>
                </tr>
                <tr>
                <td>CFE : exonération la première année, sinon aproximativement 1500€</td>
                <td>0,00 €</td>
                <td>{formatEUro(1500/12)}</td>
                </tr>
                <tr>
                <td>Total des charges obligatoires</td>
                <td>{formatEUro((caMicroMonth*0.11)+(758/12)+(103/12)+(caMicroMonth*0.022))}</td>
                <td>{formatEUro((caMicroMonth*0.22)+(caMicroMonth*0.02)+(caMicroMonth*0.022)+(1500/12))}</td>
                </tr>
                <tr className="totalAREcaByMonth">
                <td>Bénéfices</td>
                <td>{formatEUro(caMicroMonth-((caMicroMonth*0.11)+(758/12)+(103/12)+(caMicroMonth*0.022)))}</td>
                <td>{formatEUro(caMicroMonth-((caMicroMonth*0.22)+(caMicroMonth*0.02)+(caMicroMonth*0.022)+(1500/12)))}</td>
                </tr>
                
                <tr>
                <td>Total des charges externes par an</td>
                <td colSpan='2' className="inputChange"><input type="number"  placeholder="---" name="caByMonth" id="caByMonth" required onChange={(e) => { setexternalCharge(e.target.value/12) }} /></td>
                </tr>
                <tr className="totalAREcaByMonth">
                <td>Bénéfices - Charges externes</td>
                <td>{formatEUro(caMicroMonth-externalCharge-((caMicroMonth*0.11)+(758/12)+(103/12)+(caMicroMonth*0.022)))}</td>
                <td>{formatEUro(caMicroMonth-externalCharge-((caMicroMonth*0.22)+(caMicroMonth*0.02)+(caMicroMonth*0.022)+(1500/12)))}</td>
                </tr>
            </tbody>
          </table>


          <table className="microYears">
            <thead>
              <tr>
                <th>Estimation par AN<br/>Micro Entreprise (jusqu'à 72600 euros de CA)</th>
                <th>2021</th>
                <th>2022</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chiffre d'affaire</td>
                <td colSpan='2' className="inputChange"><input type="number" placeholder="---"  name="caByMonth" id="caByMonth"  required onChange={(e) => { setCaMicroYears(e.target.value) }} /></td>
               
              </tr>
              <tr>
                <td>Charges sociales
                  <ul>
                    <li>Avec l'Acre (11% du CA, CSG/CRDS de 758€, contribution à la formation professionnelles 103€)</li>
                    <li>Sans l'Acre (22% du CA, contribution à la formation professionnelles 0.2% du CA)</li>
                  </ul>
                </td>
                <td>{formatEUro((caMicroYears*0.11)+(758)+(103))}</td>
                <td>{formatEUro((caMicroYears*0.22)+(caMicroYears*0.02))}</td>
                </tr>
                <tr>
                <td>Impôt : Versement libératoire de 2.2% du CA</td>
                <td>{formatEUro(caMicroYears*0.022)}</td>
                <td>{formatEUro(caMicroYears*0.022)}</td>
                </tr>
                <tr>
                <td>CFE : exonération la première année, sinon aproximativement 1500€</td>
                <td>0,00 €</td>
                <td>{formatEUro(1500)}</td>
                </tr>
                <tr>
                <td>Total des charges obligatoires</td>
                <td>{formatEUro((caMicroYears*0.11)+(758)+(103)+(caMicroYears*0.022))}</td>
                <td>{formatEUro((caMicroYears*0.22)+(caMicroYears*0.02)+(caMicroYears*0.022)+(1500))}</td>
                </tr>
                <tr className="totalAREcaByMonth">
                <td>Bénéfices</td>
                <td>{formatEUro(caMicroYears-((caMicroYears*0.11)+(758)+(103)+(caMicroYears*0.022)))}</td>
                <td>{formatEUro(caMicroYears-((caMicroYears*0.22)+(caMicroYears*0.02)+(caMicroYears*0.022)+(1500)))}</td>
                </tr>
                
                <tr>
                <td>Total des charges externes par an</td>
                <td colSpan='2' className="inputChange"><input type="number"  placeholder="---" name="caByMonth" id="caByMonth" required onChange={(e) => { setexternalCharge(e.target.value) }} /></td>
                </tr>
                <tr className="totalAREcaByMonth">
                <td>Bénéfices - Charges externes</td>
                <td>{formatEUro(caMicroYears-externalCharge-((caMicroYears*0.11)+(758)+(103)+(caMicroYears*0.022)))}</td>
                <td>{formatEUro(caMicroYears-externalCharge-((caMicroYears*0.22)+(caMicroYears*0.02)+(caMicroYears*0.022)+(1500)))}</td>
                </tr>
            </tbody>
          </table>


    </div>
  )
}
